import { createContext } from 'react';

import { VulnerabilitySummary } from '@totem/components/vulnerabilities/overviewSummary/types';

interface Context {
  loading: boolean;
  data: VulnerabilitySummary;
}

export default createContext<Context>({
  loading: false,
  data: null,
});
